/** Groups timestamps into "Today" / "Yesterday" / calendar-date buckets, for the Requests tab. */

const dateFormatter = new Intl.DateTimeFormat(undefined, { day: "numeric", month: "long", year: "numeric" });

function startOfLocalDay(ms: number): number {
  const d = new Date(ms);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

/** Stable grouping key — same local calendar day always co-groups, regardless of time-of-day. */
export function dateGroupKey(ms: number): string {
  return String(startOfLocalDay(ms));
}

/** Human label for a group key's day, relative to now. */
export function dateGroupLabel(ms: number): string {
  const dayStart = startOfLocalDay(ms);
  const todayStart = startOfLocalDay(Date.now());
  const daysAgo = Math.round((todayStart - dayStart) / 86_400_000);

  if (daysAgo === 0) return "Today";
  if (daysAgo === 1) return "Yesterday";
  return dateFormatter.format(dayStart);
}
